import httpClient from '@/services/httpClient'
import { RebrandedBrandColors } from '@conexasaude/conexa-hero'

export default {
  getClinicColorsById(clinicId: number): Promise<RebrandedBrandColors> {
    return httpClient
      .get(`/whitelabel/config/cores/${clinicId}/v2`)
      .then(res => res.data.object)
      .catch(() => {
        return null
      })
  },
  getClinicColorsByUniqueCode(
    uniqueCode: string,
  ): Promise<RebrandedBrandColors> {
    return httpClient
      .get(`/whitelabel/config/cores/codigo_unico/${uniqueCode}/v2`)
      .then(res => res.data.object)
      .catch(() => {
        return null
      })
  },
}
